import { onAccountUpdate } from '../sogni-client.svelte.js';
import { readImageReference } from '../utils/image-reference.js';

export const imageReferences = $state({
  assets: [], guideImage: null, guideStrength: 0.5,
  revision: 0, isLoading: false, error: null
});

let owner = null;
let loadEpoch = 0;
let pendingLoads = 0;

onAccountUpdate((account) => {
  const next = account.authenticated ? account.username : null;
  if (owner && next !== owner) clearImageReferences();
  owner = next;
});

export async function addReferenceImage(file, { enabled = true, role = 'reference' } = {}) {
  const epoch = loadEpoch;
  pendingLoads += 1;
  imageReferences.isLoading = true;
  imageReferences.error = null;
  try {
    const asset = await readImageReference(file, { role, enabled });
    if (epoch !== loadEpoch) return null;
    if (role === 'guide') imageReferences.guideImage = asset;
    else imageReferences.assets = [...imageReferences.assets, asset];
    imageReferences.revision += 1;
    return asset;
  } catch (error) {
    if (epoch === loadEpoch) imageReferences.error = error.message || 'Unable to read this image.';
    throw error;
  } finally {
    if (epoch === loadEpoch) {
      pendingLoads -= 1;
      imageReferences.isLoading = pendingLoads > 0;
    }
  }
}

export function removeReferenceImage(id) {
  if (imageReferences.guideImage?.id === id) imageReferences.guideImage = null;
  else imageReferences.assets = imageReferences.assets.filter((asset) => asset.id !== id);
  imageReferences.revision += 1;
}

export function setReferenceEnabled(id, enabled) {
  imageReferences.assets = imageReferences.assets.map((asset) => asset.id === id
    ? { ...asset, enabled } : asset);
  imageReferences.revision += 1;
}

export function moveReferenceImage(id, direction) {
  const assets = [...imageReferences.assets];
  const index = assets.findIndex((asset) => asset.id === id);
  const target = index + direction;
  if (index < 0 || target < 0 || target >= assets.length) return;
  [assets[index], assets[target]] = [assets[target], assets[index]];
  imageReferences.assets = assets;
  imageReferences.revision += 1;
}

export function setGuideStrength(value) {
  imageReferences.guideStrength = Number(value);
  imageReferences.revision += 1;
}

export function clearImageReferences() {
  loadEpoch += 1;
  pendingLoads = 0;
  imageReferences.assets = [];
  imageReferences.guideImage = null;
  imageReferences.guideStrength = 0.5;
  imageReferences.isLoading = false;
  imageReferences.error = null;
  imageReferences.revision += 1;
}

export function restoreImageReferences(snapshot = {}) {
  clearImageReferences();
  imageReferences.assets = (snapshot.assets || []).map((asset) => ({ ...asset }));
  imageReferences.guideImage = snapshot.guideImage ? { ...snapshot.guideImage } : null;
  imageReferences.guideStrength = snapshot.guideStrength ?? 0.5;
  imageReferences.revision = Math.max(imageReferences.revision, Number(snapshot.revision) || 0) + 1;
}
